import * as actions from './redux/actions';
import * as homeActions from '../../home/redux/actions';

import {
  KuposErrorSuccessModal,
  KuposSuccessFailure,
  NewSearchBox,
  ServiceFilter,
} from '../../common';
import React, { Component } from 'react';

import ApiUrls from '../../../services/apiUrls';
import CommonService from '../../../services/commonService';
import DateService from '../../../services/dateService';
import { Helmet } from 'react-helmet';
import KuposCapsuleMenu from '../../common/KuposCapsuleMenu';
import KuposSteps from '../../common/KuposSteps';
import PropTypes from 'prop-types';
import SelectedServiceMore from './SelectedServiceMore/SelectedServiceMore';
import ServiceItem from './ServiceItem/ServiceItem';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

// import * as homeActions from '../home/redux/actions';

// import ServiceFilter from './ServiceFilter';

const cities = [
  { value: '1', label: 'Santiago' },
  { value: '2', label: 'Puerto mont' },
  { value: '3', label: 'Vina del mar' },
];

const filtersArray = [
  {
    title: 'DEPTARTURE_TIME',
    type: 'time',
    align: 'left',
    options: [
      { icon: 'sunrise', value: 'sunrise', label: 'Antes de las 6AM', trText: 'SUNRISE' },
      { icon: 'morning', value: 'morning', label: '6AM a 12AM', trText: 'MORNING' },
      { icon: 'sunset', value: 'sunset', label: '12AM a 18PM', trText: 'SUNSET' },
      { icon: 'night', value: 'night', label: 'Despues de las 18PM', trText: 'NIGHT' },
    ],
  },
];
let seatsSelected = 0;

export class DefaultPageTrain extends Component {
  static propTypes = {
    pbServiceList: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  capsuleMenuIcons = [
    {
      icon: '/images/icons/service-sort/icon-clock-line.png',
      iconActive: '/images/icons/service-sort/icon-clock-line-pink.png',
      label: 'SCHEDULES_DAY_NIGHT',
      sortFeild: 'dep_time',
    },
    {
      icon: '/images/icons/service-sort/icon-bus-line.png',
      iconActive: '/images/icons/service-sort/icon-bus-line-pink.png',
      label: 'COMAPNIES_ATOZ',
      sortFeild: 'operator_service_name',
    },
    {
      icon: '/images/icons/service-sort/icon-piggybank-line.png',
      iconActive: '/images/icons/service-sort/icon-piggybank-line-pink.png',
      label: 'BEST_PRICE',
      sortFeild: 'fare_str',
    },
    {
      icon: '/images/icons/service-sort/icon-star-line.png',
      iconActive: '/images/icons/service-sort/icon-star-line-pink.png',
      label: 'BEST_RANKING',
      sortFeild: 'rating',
    },
    {
      icon: '/images/icons/service-sort/icon-chronometer-line.png',
      iconActive: '/images/icons/service-sort/icon-chronometer-line-pink.png',
      label: 'FASTER',
      sortFeild: 'duration',
    },
  ];
  filtersAdded = false;

  constructor(props) {
    super(props);
    this.serviceLoaded = false;
    // console.log(this.props);
    // let fromPaymentGateway = localStorage.getItem('paymentGatewayOpened');
    // if (fromPaymentGateway) {
    //   this.props.history.replace(``, null);
    //   this.props.history.push(`/booking/failure`);
    // }
    localStorage.removeItem('paymentGatewayOpened');
    this.originCityDecoded = this.props.match.params.originOnward
      .split('--')
      .join('+')
      .split('-')
      .join(' ')
      .split('+')
      .join('-')
      .toLowerCase();
    this.destCityDecoded = this.props.match.params.destOnward
      .split('--')
      .join('+')
      .split('-')
      .join(' ')
      .split('+')
      .join('-')
      .toLowerCase();
    this.state = {
      getServiceListPending: true,
      serviceList: null,
      openNewSearch: false,
      stepsMenu: [
        { label: 'GOING', active: true },
        { label: 'RETURN' },
        { label: 'PAYMENT' },
        { label: 'CONFIRMATION' },
      ],
      activeSortTab: 2,
      originIdOnward: null,
      destIdOnward: null,
      journeyDateOnward: null,
      selectedService: null,
      orderBy: 'ASC',
      // floor: this.props.pbServiceList.selectedServiceOnward.upperAvalibility ? 'upper' : 'lower',
      floor: 0,
      filtersArray: [
        {
          title: 'DEPTARTURE_TIME',
          type: 'time',
          align: 'left',
          options: [
            { icon: 'sunrise', value: 'sunrise', label: 'Antes de las 6AM', trText: 'SUNRISE' },
            { icon: 'morning', value: 'morning', label: '6AM a 12AM', trText: 'MORNING' },
            { icon: 'sunset', value: 'sunset', label: '12AM a 18PM', trText: 'SUNSET' },
            { icon: 'night', value: 'night', label: 'Despues de las 18PM', trText: 'NIGHT' },
          ],
        },
      ],
    };
    this.operatorId = CommonService.getParameterByName('operator_id');
  }

  // componentWillMount() {
  //   console.log('componentWillMount called ---------');
  // }

  componentDidMount() {
    // console.log('PB service componentDidMount-------', this.props.pbServiceList);
    // console.log("CommonService.getLocal('pbServiceList')", CommonService.getLocal('pbServiceList'));

    seatsSelected = 0;
    try {
      localStorage.removeItem('paymentGatewayOpened');
      this._isMounted = true;
      window.onpopstate = e => {
        //your code...
        if (this._isMounted) {
          this.componentDidMount();
        }
      };
      CommonService.newSearchFunction = this.newSearch.bind(this);
      window.scrollTo(0, 0);
      const {
        pageType,
        originOnward,
        destOnward,
        tripStep,
        journeyDateOnward,
        journeyDateReturn,
      } = this.props.match.params;
      this.pageType = pageType;
      this.tripStep = tripStep;
      this.originOnward = decodeURI(originOnward);
      this.destOnward = decodeURI(destOnward);
      this.journeyDateOnward = journeyDateOnward;
      //return
      this.journeyDateReturn = journeyDateReturn;
      let pbServiceList = CommonService.getLocal('pbServiceList');
      if (pbServiceList) {
        let home = CommonService.getLocal('home');
        CommonService.removeLocal('pbServiceList');
        if (home) {
          if (this.tripStep == 2) {
            this.loadServices(
              home.pbDestinationCity.value,
              home.pbSourceCity.value,
              DateService.changeDateFormat(home.returnPBDate, 'dd-mm-yyyy', 'yyyy-mm-dd'),
              2,
            );
          } else {
            this.loadServices(
              home.pbSourceCity.value,
              home.pbDestinationCity.value,
              DateService.changeDateFormat(home.onwardPBDate, 'dd-mm-yyyy', 'yyyy-mm-dd'),
              2,
            );
          }
        }
      } else if (
        ((CommonService.isTrain() && this.props.home.uniqueCitiesTrain) ||
          (!CommonService.isTrain() && this.props.home.uniqueCities)) &&
        this.pageType != 'passenger-details' &&
        !this.props.pbServiceList.serviceList &&
        originOnward &&
        destOnward
      ) {
        let checkOriginCity = originOnward
          .split('--')
          .join('+')
          .split('-')
          .join(' ')
          .split('+')
          .join('-')
          .toLowerCase();
        let checkDestCity = destOnward
          .split('--')
          .join('+')
          .split('-')
          .join(' ')
          .split('+')
          .join('-')
          .toLowerCase();

        let filterCities = (CommonService.isTrain()
          ? this.props.home.uniqueCitiesTrain
          : this.props.home.uniqueCities
        ).filter(it => {
          return (
            it.label.toLowerCase() == checkOriginCity || it.label.toLowerCase() == checkDestCity
          );
        });
        if (filterCities) {
          let originCity = filterCities.find(it => {
            return it.label.toLowerCase() == checkOriginCity;
          });
          let destCity = filterCities.find(it => {
            return it.label.toLowerCase() == checkDestCity;
          });
          if (originCity && destCity) {
            this.sourceCityOnChange(originCity);
            this.destinationCityOnChange(destCity);
            this.originIdOnward = originCity.value;
            this.destIdOnward = destCity.value;
          }
        }
      } else if (this.props.home.pbSourceCity && this.props.home.pbDestinationCity) {
        this.originIdOnward = this.props.home.pbSourceCity.value;
        this.destIdOnward = this.props.home.pbDestinationCity.value;
      }
      this.onLoadSetup();
    } catch (e) {
      console.log(e);
    }
  }

  onLoadSetup = () => {
    try {
      this.onwardDateChange(this.journeyDateOnward);
      if (!this.journeyDateReturn) this.setupStepMenu(1, 1);
      else this.setupStepMenu(1, 2);
      if (this.journeyDateReturn) this.returnDateChange(this.journeyDateReturn);

      if (
        (!this.journeyDateReturn || this.tripStep == 1) &&
        this.originIdOnward &&
        this.destIdOnward
      ) {
        this.loadServices(
          this.originIdOnward,
          this.destIdOnward,
          DateService.changeDateFormat(this.journeyDateOnward, 'dd-mm-yyyy', 'yyyy-mm-dd'),
          1,
        );
      } else if (this.tripStep == 2) {
        //test code to check if it is working when going back from payments page to searclist page return
        this.loadServices(
          this.destIdOnward,
          this.originIdOnward,
          DateService.changeDateFormat(this.journeyDateReturn, 'dd-mm-yyyy', 'yyyy-mm-dd'),
          2,
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  componentDidUpdate() {
    try {
      const {
        pageType,
        originOnward,
        destOnward,
        tripStep,
        journeyDateOnward,
        journeyDateReturn,
      } = this.props.match.params;
      this.pageType = pageType;
      this.tripStep = tripStep;
      this.originOnward = originOnward;
      this.destOnward = destOnward;
      if (this.tripStep == 1) {
        if (this.stapMenuActive != 1) {
          this.setupStepMenu(1, 2);
        }
      } else if (this.tripStep == 2) {
        if (this.stapMenuActive != 2) {
          this.setupStepMenu(2, 2);
        }
      } else {
        if (this.stapMenuActive != 1) {
          this.setupStepMenu(1, 1);
        }
      }
      if (this.routesRes && !this.filtersAdded && this.props.home.metaData) {
        this.filtersAdded = true;
        this.createFilters(this.routesRes);
      }
      if (
        ((CommonService.isTrain() && this.props.home.uniqueCitiesTrain) ||
          (!CommonService.isTrain() && this.props.home.uniqueCities)) &&
        this.pageType != 'passenger-details' &&
        !this.props.pbServiceList.serviceList
      ) {
        if (this.tripStep == 2) {
          this.props.history.push(
            `/${i18next.language}/${
              CommonService.isTrain()
                ? i18next.language == 'es'
                  ? 'pasajes-tren'
                  : 'train-tickets'
                : i18next.language == 'es'
                ? 'pasajes-bus'
                : 'bus-tickets'
            }/${originOnward}/${destOnward}/${journeyDateOnward}/${journeyDateReturn}/1`,
          );
        } else {
          let checkOriginCity = originOnward
            .split('--')
            .join('+')
            .split('-')
            .join(' ')
            .split('+')
            .join('-')
            .toLowerCase();
          let checkDestCity = destOnward
            .split('--')
            .join('+')
            .split('-')
            .join(' ')
            .split('+')
            .join('-')
            .toLowerCase();
          let filterCities = (CommonService.isTrain()
            ? this.props.home.uniqueCitiesTrain
            : this.props.home.uniqueCities
          ).filter(it => {
            return (
              it.label.toLowerCase() == checkOriginCity || it.label.toLowerCase() == checkDestCity
            );
          });
          if (filterCities && !this.props.home.pbDestinationCity && !this.props.home.pbSourceCity) {
            let originCity = filterCities.find(it => {
              return it.label.toLowerCase() == checkOriginCity;
            });
            let destCity = filterCities.find(it => {
              return it.label.toLowerCase() == checkDestCity;
            });
            let navBar = document.querySelector('.nav-section');
            if (originCity && destCity) {
              this.sourceCityOnChange(originCity);
              this.destinationCityOnChange(destCity);
              this.originIdOnward = originCity.value;
              this.destIdOnward = destCity.value;
              this.onLoadSetup();
              CommonService.removeClass(navBar, 'payments-page-header');
            } else {
              let newHeaderSearch = document.querySelector('.nav-section .common-new-search-box');
              if (!this.serviceList) {
                this.serviceList = 'NO_ROUTES_FOUND';
                this.setState({
                  serviceList: 'NO_ROUTES_FOUND',
                });
                newHeaderSearch.style.display = 'none';
                CommonService.add(navBar, 'payments-page-header');
              }
            }
          } else {
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  setupStepMenu = (step, type) => {
    try {
      let stepsMenu;
      this.stapMenuActive = step;
      if (type == 1) {
        stepsMenu = [
          { label: 'GOING', active: step == 1 },
          { label: 'PAYMENT', active: step == 2 },
          { label: 'CONFIRMATION', active: step == 3 },
        ];
      } else {
        stepsMenu = [
          { label: 'GOING', active: step == 1 },
          { label: 'RETURN', active: step == 2 },
          { label: 'PAYMENT', active: step == 3 },
          { label: 'CONFIRMATION', active: step == 4 },
        ];
      }
      this.setState({ stepsMenu: stepsMenu });
    } catch (e) {
      console.log(e);
    }
  };

  loadServices = (originId, destId, journeyDate, step = 1, retryCount = 0) => {
    this.props.actions
      .getServiceList({
        url: ApiUrls.serviceList(
          originId,
          destId,
          journeyDate,
          this.journeyDateReturn ? true : false,
          step == 2 ? true : false,
          retryCount,
        ),
      })
      .then(res => {
        try {
          const selectedServiceOnward = CommonService.copyObject(
            this.props.pbServiceList.selectedServiceOnward,
          );
          const selectedServiceReturn = CommonService.copyObject(
            this.props.pbServiceList.selectedServiceReturn,
          );
          let maxRetryCount = 0;
          if (step == 1) {
            this.retryFlag = res.retryFlag;
            this.waitTime = res.waitTime;
            if (!this.serviceLoaded) {
              this.maxRetryCount = res.maxRetryCount;
              this.serviceLoaded = true;
            }
            if (Array.isArray(res.routes) && res.routes.length) {
              this.maxRetryCount = 0;
            }
            maxRetryCount = this.maxRetryCount || 0;
            if (this.retryFlag && this.maxRetryCount > 0) {
              this.maxRetryCount--;
              retryCount++;
              setTimeout(() => {
                this.loadServices(originId, destId, journeyDate, step, retryCount);
              }, this.waitTime * 1000);
            } else {
              this.setState({
                getServiceListPending: false,
              });
              this.props.actions.setServiceListOnward(res);
              this.props.actions.setServiceOnward({
                coachLayoutJson: null,
                originStageDetails: null,
                destinationStageDetails: null,
                boardingStage: null,
                droppingStage: null,
                route: null,
              });
            }
            // console.log('Service List before set', res);
          } else {
            this.retryFlag = res.retryFlag;
            this.waitTime = res.waitTime;
            if (!this.serviceLoaded) {
              this.maxRetryCount = res.maxRetryCount;
              this.serviceLoaded = true;
            }
            if (Array.isArray(res.routes) && res.routes.length) {
              this.maxRetryCount = 0;
            }
            maxRetryCount = this.maxRetryCount || 0;
            if (this.retryFlag && this.maxRetryCount > 0) {
              this.maxRetryCount--;
              retryCount++;
              setTimeout(() => {
                this.loadServices(originId, destId, journeyDate, step, retryCount);
              }, this.waitTime * 1000);
            } else {
              this.props.actions.setServiceListReturn(res);
              this.props.actions.setServiceReturn({
                coachLayoutJson: null,
                originStageDetails: null,
                destinationStageDetails: null,
                boardingStage: null,
                droppingStage: null,
                route: null,
              });
              this.setState({
                getServiceListPending: false,
              });
            }
          }
          if (!this.retryFlag || !maxRetryCount > 0) {
            setTimeout(() => {
              if (
                step == 1 &&
                selectedServiceOnward.route &&
                this.props.pbServiceList.selectedService
              ) {
                this.props.actions.selectSeatOnward({
                  totalBookingAmount: 0,
                  netBookingAmount: 0,
                  discountAmount: 0,
                  selectedSeatsToBook: null,
                  selectedSeatsNumbers: null,
                  selectedSeatTypes: null,
                });
                this.onBookButtonPress(this.props.pbServiceList.selectedService, step);
              } else if (
                step == 2 &&
                selectedServiceReturn.route &&
                this.props.pbServiceList.selectedService
              ) {
                this.props.actions.selectSeatReturn({
                  totalBookingAmount: 0,
                  netBookingAmount: 0,
                  discountAmount: 0,
                  selectedSeatsToBook: null,
                  selectedSeatsNumbers: null,
                  selectedSeatTypes: null,
                });
                this.onBookButtonPress(this.props.pbServiceList.selectedService, step);
              }
            }, 500);
            let navBar = document.querySelector('.nav-section');
            let newHeaderSearch = document.querySelector('.nav-section .common-new-search-box');
            if (res.routes) {
              this.routesRes = res;
              if (this.props.home.metaData) this.filtersAdded = true;
              this.createFilters(res);
              if (newHeaderSearch) newHeaderSearch.style.display = 'block';
              CommonService.removeClass(navBar, 'payments-page-header');
            } else {
              this.setState({
                serviceList: 'NO_ROUTES_FOUND',
              });
              CommonService.add(navBar, 'payments-page-header');
              if (newHeaderSearch) newHeaderSearch.style.display = 'none';
            }
          }
        } catch (e) {
          console.log(e);
        }
      });
  };

  createFilters = res => {
    let filterState = CommonService.copyObject(filtersArray);
    let filters = CommonService.getServiceFilters(
      res.routes.filter(it => it.travel_id == this.operatorId || !this.operatorId),
      this.props.home.metaData,
    );
    if (filters) {
      filterState.push(filters.operators);
      filterState.push(filters.amenities);
      filterState.push(filters.seatTypes);
      this.setState({
        filtersArray: filterState,
        serviceList: res,
        activeSortTab: 0,
        orderBy: 'ASC',
        orderByField: null,
      });
      setTimeout(() => {
        this.sortBy(0, res);
      }, 100);
    }
  };

  onStepClick = menu => {
    if (this.tripStep == 2 && menu == 1) {
      window.history.go(-1);
    }
  };

  clearSelectedSeats = (type = 1) => {
    // console.log('Seats closed status', type);
    seatsSelected = 0;
    this.setState({ seatsCleared: true });
    let data = {
      totalBookingAmount: 0,
      netBookingAmount: 0,
      discountAmount: 0,
      selectedSeatsToBook: null,
      selectedSeatsNumbers: null,
      selectedSeatTypes: null,
    };
    if (type == 1) {
      // this.onSeatSelectOnward(data, true);
      this.props.actions.selectSeatOnward(data);
    } else {
      this.props.actions.selectSeatReturn(data);
      // this.onSeatSelectReturn(data, true);
    }
  };

  seatSelectedSeatsOnward = () => {
    try {
      let seats = this.selectedSeatsOnward.split(',');
      for (let seat of seats) {
        let seatObject;
        if (this.props.pbServiceList.selectedServiceOnward.coachLayoutJson)
          for (let row of this.props.pbServiceList.selectedServiceOnward.coachLayoutJson) {
            seatObject = row.find(it => it.number == seat);
            if (seatObject) {
              let bookingDetails = CommonService.selectSeat(
                seatObject,
                this.props.home.metaData,
                this.props.pbServiceList.selectedServiceOnward.coachLayoutJson,
                this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook,
              );
              this.onSeatSelectOnward(bookingDetails);
              break;
            }
          }
      }
    } catch (e) {
      console.log(e);
    }
  };
  seatSelectedSeatsReturn = () => {
    try {
      let seats = this.selectedSeatsReturn.split(',');
      for (let seat of seats) {
        let seatObject;
        if (this.props.pbServiceList.selectedServiceReturn.coachLayoutJson)
          for (let row of this.props.pbServiceList.selectedServiceReturn.coachLayoutJson) {
            seatObject = row.find(it => it.number == seat);
            if (seatObject) {
              let bookingDetails = CommonService.selectSeat(
                seatObject,
                this.props.home.metaData,
                this.props.pbServiceList.selectedServiceReturn.coachLayoutJson,
                this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook,
              );
              this.onSeatSelectReturn(bookingDetails);
              break;
            }
          }
      }
    } catch (e) {
      console.log(e);
    }
  };

  onwardDateChange = date => {
    this.props.actions.setOnwardPbDate(date);
  };

  returnDateChange = date => {
    this.props.actions.setReturnPbDate(date);
  };

  sourceCityOnChange = value => {
    // console.log('Value of origin', value);
    this.props.actions.pbSetSourceCity(value);
  };
  destinationCityOnChange = value => {
    // console.log('Value of dest', value);
    this.props.actions.pbSetDestinationCity(value);
  };

  onBoardingPointChange = value => {
    try {
      if (this.tripStep != 2) {
        this.setState({ boardingErrorMessage: null });
        let stage =
          this.props.pbServiceList.selectedServiceOnward.originStageDetails &&
          this.props.pbServiceList.selectedServiceOnward.originStageDetails.find(
            it => it.id == value.value,
          );
        let serviceDetails = this.props.pbServiceList.selectedServiceOnward;
        serviceDetails.boardingStage = stage;
        this.props.actions.setServiceOnward(serviceDetails);
      } else {
        this.setState({ boardingErrorMessage: null });
        let stage =
          this.props.pbServiceList.selectedServiceReturn.originStageDetails &&
          this.props.pbServiceList.selectedServiceReturn.originStageDetails.find(
            it => it.id == value.value,
          );
        let serviceDetails = this.props.pbServiceList.selectedServiceReturn;
        serviceDetails.boardingStage = stage;
        this.props.actions.setServiceReturn(serviceDetails);
      }
    } catch (e) {
      console.log(e);
    }
  };

  onDroppingPointChange = value => {
    try {
      if (this.tripStep != 2) {
        this.setState({ droppingErrorMessage: null });
        let stage =
          this.props.pbServiceList.selectedServiceOnward.destinationStageDetails &&
          this.props.pbServiceList.selectedServiceOnward.destinationStageDetails.find(
            it => it.id == value.value,
          );
        let serviceDetails = this.props.pbServiceList.selectedServiceOnward;
        serviceDetails.droppingStage = stage;
        this.props.actions.setServiceOnward(serviceDetails);
      } else {
        this.setState({ droppingErrorMessage: null });
        let stage =
          this.props.pbServiceList.selectedServiceReturn.destinationStageDetails &&
          this.props.pbServiceList.selectedServiceReturn.destinationStageDetails.find(
            it => it.id == value.value,
          );
        let serviceDetails = this.props.pbServiceList.selectedServiceReturn;
        serviceDetails.droppingStage = stage;
        this.props.actions.setServiceReturn(serviceDetails);
      }
    } catch (e) {
      console.log(e);
    }
  };

  sortBy = (i, arr) => {
    try {
      let orderBy = i === 1 || i === 2 || i === 3 ? 'DESC' : 'ASC';
      let sortFeild = this.capsuleMenuIcons[i].sortFeild;
      if (this.dateChanged) {
        orderBy = this.state.orderBy;
      }
      if (this.state.orderByField == sortFeild) {
        if (this.state.orderBy === 'ASC') {
          orderBy = 'DESC';
        } else if (this.state.orderBy === 'DESC' && (i === 1 || i === 2 || i === 3)) {
          orderBy = 'ASC';
        }
      }
      let routes;
      if (!arr)
        if (this.tripStep == 2) {
          routes = CommonService.copyObject(this.state.serviceList);
        } else {
          routes = CommonService.copyObject(this.state.serviceList);
        }
      else routes = CommonService.copyObject(arr);

      let routesFull = this.sortThis(routes.routes, sortFeild, orderBy);
      // let routes = routesFull.filter(it => {
      //   return it.available_seats > 0;
      // })
      // let soldRoutes = routesFull.filter(it => {
      //   return it.available_seats <= 0;
      // })
      // for(let route of soldRoutes){
      //   route.soldRoute = true
      // }
      routes.routes = routesFull;
      this.setState({
        orderByField: sortFeild,
        orderBy: orderBy,
        activeSortTab: i,
        serviceList: routes,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * ascending descending method
   */
  isAsc = () => {
    if (this.state.orderBy === 'ASC') {
      return true;
    } else {
      return false;
    }
  };

  /**
   * sort method
   */
  sortThis = (arr, orderByValue, orderType = 'ASC') => {
    try {
      arr.sort((a, b) => {
        if (orderType === 'ASC') {
          if (orderByValue == 'operator_service_name') {
            if (a[orderByValue] < b[orderByValue]) return 1;
            if (a[orderByValue] > b[orderByValue]) return -1;
            return 0;
          } else if (orderByValue == 'dep_time') {
            // return (Date.parse('1970/01/01 ' + a[orderByValue]) - Date.parse('1970/01/01 ' + b[orderByValue]))
            if (a[orderByValue] < b[orderByValue]) return -1;
            if (a[orderByValue] > b[orderByValue]) return 1;
            return 0;
          } else if (orderByValue == 'rating') {
            if (a.operator_details[1] < b.operator_details[1]) return -1;
            if (a.operator_details[1] > b.operator_details[1]) return 1;
            return 0;
          } else if (orderByValue == 'duration') {
            if (a[orderByValue] < b[orderByValue]) return -1;
            if (a[orderByValue] > b[orderByValue]) return 1;
            return 0;
          } else {
            if (a[orderByValue] && b[orderByValue]) {
              let aValue = a[orderByValue].split(':');
              let bValue = b[orderByValue].split(':');
              if (Number.parseInt(aValue[1]) < Number.parseInt(bValue[1])) return 1;
              if (Number.parseInt(aValue[1]) > Number.parseInt(bValue[1])) return -1;
            }
            return 0;
          }
        } else {
          if (orderByValue == 'operator_service_name') {
            if (a[orderByValue] < b[orderByValue]) return -1;
            if (a[orderByValue] > b[orderByValue]) return 1;
            return 0;
          } else if (orderByValue == 'dep_time') {
            // return -(Date.parse('1970/01/01 ' + a[orderByValue]) - Date.parse('1970/01/01 ' + b[orderByValue]))
            if (a[orderByValue] < b[orderByValue]) return 1;
            if (a[orderByValue] > b[orderByValue]) return -1;
            return 0;
          } else if (orderByValue == 'rating') {
            if (a.operator_details[1] < b.operator_details[1]) return 1;
            if (a.operator_details[1] > b.operator_details[1]) return -1;
            return 0;
          } else if (orderByValue == 'duration') {
            if (a[orderByValue] < b[orderByValue]) return 1;
            if (a[orderByValue] > b[orderByValue]) return -1;
            return 0;
          } else {
            if (a[orderByValue] && b[orderByValue]) {
              let aValue = a[orderByValue].split(':');
              let bValue = b[orderByValue].split(':');
              if (Number.parseInt(aValue[1]) > Number.parseInt(bValue[1])) return 1;
              if (Number.parseInt(aValue[1]) < Number.parseInt(bValue[1])) return -1;
            }
            return 0;
          }
        }
      });
    } catch (e) {
      console.log(e);
    }
    return arr;
  };

  // onServiceSelect = (service) => {
  //   if (service.available_seats <= 0) {
  //     return false;
  //   }
  //   this.getServiceDetails(service.id,service);
  // }

  onBookButtonPress = (service, step) => {
    if (service.available_seats <= 0) {
      return false;
    }
    this.clearSelectedSeats(step);
    this.props.actions.setSelectedService(null);
    this.setState({
      selectedService: service,
      floor: 0,
    });
    this.getServiceDetails(service.id, service, step);
    // this.props.actions.setSelectedService(CommonService.setSeatLayout(CommonService.makeServiceDetailsApi(layout),route));
  };

  getServiceDetails(scheduleId, route, step) {
    // store

    console.log('testing getServiceDetails-------', route);

    this.setState({
      selectedServiceError: null,
    });
    this.props.actions
      .getSelectedService({
        url: ApiUrls.serviceDetails(
          scheduleId,
          this.journeyDateReturn ? true : false,
          step == 2 ? true : false,
        ),
      })
      .then(selectedService => {
        if (selectedService && !selectedService.error) {
          // console.log('Selected Service details', selectedService);
          this.onServiceDetailsResponse(selectedService, scheduleId, route, step);
          this.props.actions.setSelectedService(selectedService);
        } else {
          this.setState({
            selectedServiceError:
              (selectedService && selectedService.error.message) ||
              this.props.t('RESULTS_PAGE.SOLD_OUT_MSG'),
          });
        }
      });
  }

  onServiceDetailsResponse = (selectedService, scheduleId, route, step) => {
    if (selectedService) {
      this.checkSeatAvailability(selectedService, scheduleId, route, step);
    }
  };

  checkSeatAvailability = (serviceDetails, scheduleId, route, step) => {
    try {
      if (serviceDetails) {
        if (serviceDetails.total_available_seats > 0) {
          if (!step || step == 1) {
            // console.log(
            //   'CommonService.setSeatLayout(serviceDetails, route)',
            //   CommonService.setSeatLayout(serviceDetails, route),
            // );
            this.props.actions.setServiceOnward(CommonService.setSeatLayout(serviceDetails, route));
          } else {
            this.props.actions.setServiceReturn(CommonService.setSeatLayout(serviceDetails, route));
          }
          // CommonService.goToScreen(this.props.componentId,SERVICE_DETAILS_SCREEN,'Selecciona tu asiento')
        } else {
          this.setState({
            selectedServiceError: this.props.t('RESULTS_PAGE.SOLD_OUT_MSG'),
          });
          let list = JSON.parse(
            JSON.stringify(
              !step || step == 1 ? this.props.data.serviceList : this.props.data.serviceListReturn,
            ),
          );
          for (let i in list.routes) {
            if (list.routes[i].id == scheduleId) {
              list.routes[i].available_seats = 0;
              !step || step == 1
                ? this.props.actions.setServiceListOnward(list)
                : this.props.actions.setServiceListReturn(list);
              break; //Stop this loop, we found it!
            }
          }
          this.setRoutes();
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  floorChange = floor => {
    this.setState({
      floor: floor,
    });
  };

  onSeatSelectOnward = (bookingDetails, reset = false) => {
    // console.log('Booking details-------', bookingDetails);

    if (bookingDetails && bookingDetails.selectedSeatsNumbers) {
      seatsSelected = bookingDetails.selectedSeatsNumbers.split(',').length;
      // seatsSelected++;
    }

    // console.log(seatsSelected);
    sessionStorage.removeItem('paymentCounter');
    // console.log('Data is ', bookingDetails.selectedSeatsToBook ? bookingDetails.selectedSeatsToBook.length : "No Seats");
    if (
      bookingDetails.selectedSeatsToBook &&
      bookingDetails.selectedSeatsToBook.length <=
        ((this.props.pbServiceList.selectedService &&
          this.props.pbServiceList.selectedService.res_details &&
          this.props.pbServiceList.selectedService.res_details.no_of_seats_to_be_booked) ||
          8) &&
      bookingDetails != 'NO_AVAILABLE'
    ) {
      this.props.actions.selectSeatOnward(bookingDetails);
      // console.log("Logged", "hello");
    } else if (
      (bookingDetails.selectedSeatsToBook && bookingDetails.selectedSeatsToBook.length) >=
      ((this.props.pbServiceList.selectedService &&
        this.props.pbServiceList.selectedService.res_details &&
        this.props.pbServiceList.selectedService.res_details.no_of_seats_to_be_booked) ||
        8)
    ) {
      // console.log('More than 8 seats');
      this.setState({
        showFilterModal: true,
        showFilterModalMessage: 'VALIDATIONS.MAX_SEAT_COUNT',
      });
    }
    if (reset) {
      this.props.actions.selectSeatOnward(bookingDetails);
    }

    // if(bookingDetails.selectedSeatsToBook){
    //   bookingDetails.selectedSeatsToBook.length == 8 ?
    // }
    // else
    // this.refs.toast.show('Máximo ' + this.props.data.bookingDetailsOnward.selectedSeatsToBook.length + ' asientos permitidos por compra');
  };

  onSeatSelectReturn = bookingDetails => {
    if (bookingDetails && bookingDetails.selectedSeatsNumbers) {
      seatsSelected = bookingDetails.selectedSeatsNumbers.split(',').length;
      // seatsSelected++;
    }

    console.log(seatsSelected);

    sessionStorage.removeItem('paymentCounter');
    // console.log('Data is ', bookingDetails.selectedSeatsToBook ? bookingDetails.selectedSeatsToBook.length : "No Seats");
    if (
      bookingDetails.selectedSeatsToBook &&
      bookingDetails.selectedSeatsToBook.length <=
        ((this.props.pbServiceList.selectedService.res_details &&
          this.props.pbServiceList.selectedService.res_details.no_of_seats_to_be_booked) ||
          8) &&
      bookingDetails != 'NO_AVAILABLE'
    ) {
      this.props.actions.selectSeatReturn(bookingDetails);
      // console.log("Logged", "hello");
    } else if (
      (bookingDetails.selectedSeatsToBook && bookingDetails.selectedSeatsToBook.length) >=
      ((this.props.pbServiceList.selectedService &&
        this.props.pbServiceList.selectedService.res_details &&
        this.props.pbServiceList.selectedService.res_details.no_of_seats_to_be_booked) ||
        8)
    ) {
      // console.log('More than 8 seats');
      this.setState({
        showFilterModal: true,
        showFilterModalMessage: 'VALIDATIONS.MAX_SEAT_COUNT',
      });
    }
  };

  continue = () => {
    try {
      if (this.tripStep != 2) {
        if (
          !this.props.pbServiceList.bookingDetailsOnward ||
          !this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook ||
          !this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook.length
        ) {
          // this.refs.toast.show('Selecciona tu asiento');
          return;
        }
        if (
          !this.props.pbServiceList.selectedServiceOnward ||
          !this.props.pbServiceList.selectedServiceOnward.boardingStage
        ) {
          // this.refs.toast.show('Seleccione punto de embarque');
          this.setState({ boardingErrorMessage: 'Seleccione punto de embarque' });
          return;
        }
        if (
          !this.props.pbServiceList.selectedServiceOnward ||
          !this.props.pbServiceList.selectedServiceOnward.droppingStage
        ) {
          // this.refs.toast.show('Seleccione punto de llegada');
          this.setState({ droppingErrorMessage: 'Seleccione punto de llegada' });
          return;
        }
      } else {
        if (
          !this.props.pbServiceList.bookingDetailsReturn ||
          !this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook ||
          !this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook.length
        ) {
          // this.refs.toast.show('Selecciona tu asiento');
          return;
        }
        if (
          !this.props.pbServiceList.selectedServiceReturn ||
          !this.props.pbServiceList.selectedServiceReturn.boardingStage
        ) {
          // this.refs.toast.show('Seleccione punto de embarque');
          this.setState({ boardingErrorMessage: 'Seleccione punto de embarque' });
          return;
        }
        if (
          !this.props.pbServiceList.selectedServiceReturn ||
          !this.props.pbServiceList.selectedServiceReturn.droppingStage
        ) {
          // this.refs.toast.show('Seleccione punto de llegada');
          this.setState({ droppingErrorMessage: 'Seleccione punto de llegada' });
          return;
        }
      }
      this.setState({ boardingErrorMessage: null });
      this.setState({ droppingErrorMessage: null });
      if (!this.props.home.returnPBDate) {
        CommonService.setLocal('pbServiceList', this.props.pbServiceList);

        //GO to Payment Page logic
        let home = {
          onwardPBDate: this.props.home.onwardPBDate,
          pbSourceCity: this.props.home.pbSourceCity,
          pbDestinationCity: this.props.home.pbDestinationCity,
          metaData: this.props.home.metaData,
        };
        CommonService.setLocal('home', home);
        this.props.history.push(`/${i18next.language}/booking`);
      } else {
        if (this.tripStep == 1) {
          this.tripStep = 2;
          this.props.history.push(
            `/${i18next.language}/${
              CommonService.isTrain()
                ? i18next.language == 'es'
                  ? 'pasajes-tren'
                  : 'train-tickets'
                : i18next.language == 'es'
                ? 'pasajes-bus'
                : 'bus-tickets'
            }/${this.originOnward}/${this.destOnward}/${this.journeyDateOnward}/${
              this.journeyDateReturn
            }/2`,
          );
          this.setupStepMenu(2, 2);
          this.loadServices(
            this.props.home.pbDestinationCity.value,
            this.props.home.pbSourceCity.value,
            DateService.changeDateFormat(this.props.home.returnPBDate, 'dd-mm-yyyy', 'yyyy-mm-dd'),
            2,
          );
        } else {
          CommonService.setLocal('pbServiceList', this.props.pbServiceList);

          let home = {
            onwardPBDate: this.props.home.onwardPBDate,
            returnPBDate: this.props.home.returnPBDate,
            pbSourceCity: this.props.home.pbSourceCity,
            pbDestinationCity: this.props.home.pbDestinationCity,
            metaData: this.props.home.metaData,
          };
          CommonService.setLocal('home', home);
          this.props.history.push(`/${i18next.language}/booking`);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  renderSelectedSearchBox = () => {
    const { t } = this.props;
    return (
      <div className="content-container">
        <div className="selected-search-box">
          <div className="selected-search-values font10">
            <div className="selected-search-item">
              <span className="selected-search-label">{t('HOME.ORIGIN')}</span>
              <span className="selected-search-value">
                {this.props.home.pbSourceCity && this.props.home.pbSourceCity.label}
              </span>
            </div>
            <div className="selected-search-item">
              <span className="selected-search-label">{t('HOME.DESTINATION')}</span>
              <span className="selected-search-value">
                {this.props.home.pbDestinationCity && this.props.home.pbDestinationCity.label}
              </span>
            </div>
            <div className="selected-search-item">
              <span className="selected-search-label">{t('HOME.GOING')}</span>
              <span className="selected-search-value">
                {DateService.getDayNameFromDate(this.props.home.onwardPBDate) +
                  ', ' +
                  DateService.getDateFromDate(this.props.home.onwardPBDate) +
                  ' ' +
                  DateService.getMonthNameFromDate(this.props.home.onwardPBDate)}
              </span>
            </div>
            {this.props.home.returnPBDate ? (
              <div className="selected-search-item">
                <span className="selected-search-label">{t('HOME.RETURN')}</span>
                <span className="selected-search-value">
                  {DateService.getDayNameFromDate(this.props.home.returnPBDate) +
                    ', ' +
                    DateService.getDateFromDate(this.props.home.returnPBDate) +
                    ' ' +
                    DateService.getMonthNameFromDate(this.props.home.returnPBDate)}
                </span>
              </div>
            ) : null}
          </div>
          <div className="new-search-button font12">
            <a
              className="new-search-button-a kupos-button-secondary"
              onClick={() => this.setState({ openNewSearch: !this.state.openNewSearch })}
            >
              NUEVA BÚSQUEDA{' '}
            </a>
            <span>
              <img src="/images/icons/home/icon_arrow_down_white.png" />
            </span>
          </div>
        </div>
      </div>
    );
  };

  newSearch = () => {
    try {
      this.serviceLoaded = false;
      this.setState({
        serviceList: '',
      });
      let newHeaderSearch = document.querySelector('.nav-section .common-new-search-box');
      if (newHeaderSearch) newHeaderSearch.style.display = 'block';
      this.props.actions.setSelectedService(null);
      this.props.actions.setServiceListOnward(null);
      this.props.actions.setServiceListReturn(null);
      this.originOnward = this.props.home.pbSourceCity
        ? this.props.home.pbSourceCity.label
            .toLowerCase()
            .replace(/-/g, '_')
            .replace(/ /g, '-')
            .replace(/_/g, '--')
        : '';
      this.destOnward = this.props.home.pbDestinationCity
        ? this.props.home.pbDestinationCity.label
            .toLowerCase()
            .replace(/-/g, '_')
            .replace(/ /g, '-')
            .replace(/_/g, '--')
        : '';
      this.journeyDateOnward = this.props.home.onwardPBDate;
      if (this.tripStep == 1) {
        this.journeyDateReturn = this.props.home.returnPBDate;
      }
      this.setState({
        filtersArray: filtersArray,
      });
      if (!this.props.home.returnPBDate) {
        this.props.history.push(
          `/${i18next.language}/${
            CommonService.isTrain()
              ? i18next.language == 'es'
                ? 'pasajes-tren'
                : 'train-tickets'
              : i18next.language == 'es'
              ? 'pasajes-bus'
              : 'bus-tickets'
          }/${this.originOnward}/${this.destOnward}/${this.props.home.onwardPBDate}`,
        );
        this.loadServices(
          this.props.home.pbSourceCity.value,
          this.props.home.pbDestinationCity.value,
          DateService.changeDateFormat(this.props.home.onwardPBDate, 'dd-mm-yyyy', 'yyyy-mm-dd'),
        );
      } else {
        this.props.history.push(
          `/${i18next.language}/${
            CommonService.isTrain()
              ? i18next.language == 'es'
                ? 'pasajes-tren'
                : 'train-tickets'
              : i18next.language == 'es'
              ? 'pasajes-bus'
              : 'bus-tickets'
          }/${this.originOnward}/${this.destOnward}/${this.props.home.onwardPBDate}/${
            this.props.home.returnPBDate
          }/1`,
        );
        this.loadServices(
          this.props.home.pbSourceCity.value,
          this.props.home.pbDestinationCity.value,
          DateService.changeDateFormat(this.props.home.onwardPBDate, 'dd-mm-yyyy', 'yyyy-mm-dd'),
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  // renderNewSearchForm = () => {
  //   return (
  //     <div className={"content-container new-search-box home-selection-input-boxes " + (this.props.pbServiceList.openNewSearch ? 'open' : '')}>

  //     <div className="home-selection-input-box">
  //       <KuposSelectBox
  //         options={cities}
  //         selectedOption={this.props.home.pbSourceCity}
  //         onChange={this.sourceCityOnChange}
  //         placeholder={'Source'}
  //         icon="/images/icons/home/icon_source.png"
  //         />
  //       {/* <div className="home-selection-input kupos-border">
  //           <img className="icon-size" src="./images/icons/home/icon_source.png"/> <span>Source</span>
  //       </div> */}
  //     </div>

  //     <div className="home-selection-input-box">
  //       <KuposSelectBox
  //         options={cities}
  //         selectedOption={this.props.home.pbDestinationCity}
  //         onChange={this.destinationCityOnChange}
  //         placeholder={'Destination'}
  //         icon="/images/icons/home/icon_source2.png"
  //         />
  //       {/* <div className="home-selection-input kupos-border">
  //           <img className="icon-size" src="./images/icons/home/icon_source2.png"/> <span>Source</span>
  //       </div> */}
  //     </div>

  //       <div className="home-selection-input-box">
  //         <KuposDatePicker  selectedDate={this.props.home.onwardPBDate} onDateChange={(date) => this.onwardDateChange(date)} />
  //         {/* <div className="home-selection-input kupos-border">
  //             <img className="icon-size" src="./images/icons/home/icon_calendar.png"/> <span>Source</span>
  //         </div> */}
  //     </div>
  //         <div className="home-selection-input-box">
  //         <KuposDatePicker  selectedDate={this.props.home.returnPBDate} onDateChange={(date) => this.returnDateChange(date)} />
  //           {/* <div className="home-selection-input kupos-border">
  //               <img className="icon-size" src="./images/icons/home/icon_calendar.png"/> <span>Source</span>
  //           </div> */}
  //         </div>

  //         <div className="home-selection-input-box">
  //               <button className="kupos-button home-selection-input-button " onClick={this.newSearch}>
  //                 <img className="icon-size" src="/images/icons/home/icon_search-white.png"/> <span>Search</span>
  //               </button>
  //         </div>
  //     </div>
  //   )
  // }

  onFilterSelected = (option, key, i) => {
    console.log('Filters option are----', option);
    console.log('Filters key are----', key);
    console.log('Filters i are----', i);
    let filters = CommonService.copyObject(this.state.filtersArray);
    filters[key].options[i].active = !filters[key].options[i].active;
    this.filterBy(filters, key);
    this.setState({
      filtersArray: filters,
    });
    // setTimeout(() => {
    //   if(this.isFilterSelected()){
    //     console.log('this.state.serviceList',this.state.serviceList)
    //     if(!this.state.serviceList || !this.state.serviceList.routes || !this.state.serviceList.routes.length){
    //       this.setState({ showFilterModal : true, showFilterModalMessage:"You cannot select more than 8 seats", filterSelected:true});
    //     }
    //   }
    // },300)
  };

  filterBy(filters, key) {
    try {
      let routes;
      if (this.tripStep == 2) {
        routes = CommonService.copyObject(this.props.pbServiceList.serviceListReturn);
      } else {
        routes = CommonService.copyObject(this.props.pbServiceList.serviceList);
      }
      let filteredRoutes = [];
      for (let fil of filters) {
        if (fil.type == 'time') {
          let activeOptions = fil.options.filter(it => it.active);
          filteredRoutes = routes.routes.filter(it => {
            for (let f of fil.options) {
              if (activeOptions && activeOptions.length) {
                if (f.active) {
                  if (f.value == 'sunrise' && it.dep_time < '06:00') {
                    return true;
                  } else if (
                    f.value == 'morning' &&
                    it.dep_time >= '06:00' &&
                    it.dep_time < '12:00'
                  ) {
                    return true;
                  } else if (
                    f.value == 'sunset' &&
                    it.dep_time >= '12:00' &&
                    it.dep_time < '18:00'
                  ) {
                    return true;
                  } else if (f.value == 'night' && it.dep_time >= '18:00') {
                    return true;
                  }
                }
              } else {
                return true;
              }
            }
          });
        }
        if (fil.type == 'operator') {
          let activeOptions = fil.options.filter(it => it.active);
          filteredRoutes = filteredRoutes.filter(it => {
            for (let f of fil.options) {
              if (activeOptions && activeOptions.length) {
                if (f.active) {
                  if (it.operator_service_name.toLowerCase().indexOf(f.value.toLowerCase()) >= 0) {
                    return true;
                  }
                }
              } else {
                return true;
              }
            }
          });
        }
        if (fil.type == 'amenities') {
          let activeOptions = fil.options.filter(it => it.active);
          filteredRoutes = filteredRoutes.filter(it => {
            for (let f of fil.options) {
              if (activeOptions && activeOptions.length) {
                if (f.active) {
                  if (it.operator_details[4]) {
                    for (let a of it.operator_details[4]) {
                      let am = this.props.home.metaData.amenities[a].split('.')[0].toLowerCase();
                      if (am.indexOf(f.value.toLowerCase()) >= 0) {
                        return true;
                      }
                    }
                  }
                }
              } else {
                return true;
              }
            }
          });
        }
        if (fil.type == 'seat_types') {
          let activeOptions = fil.options.filter(it => it.active);
          filteredRoutes = filteredRoutes.filter(it => {
            for (let f of fil.options) {
              if (activeOptions && activeOptions.length) {
                if (f.active) {
                  if (f.value.toLowerCase().indexOf('semi') > -1) {
                    for (let bt of it.fare_str.split(',')) {
                      if (
                        bt
                          .toLowerCase()
                          .split(':')[0]
                          .indexOf('semi') > -1
                      ) {
                        return true;
                      }
                    }
                  } else if (f.value.toLowerCase().indexOf('salon') > -1) {
                    for (let bt of it.fare_str.split(',')) {
                      if (
                        bt
                          .toLowerCase()
                          .split(':')[0]
                          .indexOf('salon') > -1
                      ) {
                        return true;
                      }
                    }
                  } else if (f.value.toLowerCase().indexOf('ejecutivo') > -1) {
                    for (let bt of it.fare_str.split(',')) {
                      if (
                        bt
                          .toLowerCase()
                          .split(':')[0]
                          .indexOf('ejecutivo') > -1
                      ) {
                        return true;
                      }
                    }
                  } else if (f.value.toLowerCase().indexOf('suite') > -1) {
                    for (let bt of it.fare_str.split(',')) {
                      if (
                        bt
                          .toLowerCase()
                          .split(':')[0]
                          .indexOf('suite') > -1
                      ) {
                        return true;
                      }
                    }
                  } else if (f.value.toLowerCase().indexOf('vip') > -1) {
                    for (let bt of it.fare_str.split(',')) {
                      if (
                        bt
                          .toLowerCase()
                          .split(':')[0]
                          .indexOf('vip') > -1
                      ) {
                        return true;
                      }
                    }
                  } else if (f.value.toLowerCase() == 'cama') {
                    for (let bt of it.fare_str.split(',')) {
                      if (bt.toLowerCase().split(':')[0] == 'cama') {
                        return true;
                      }
                    }
                  } else if (f.value.toLowerCase() == 'preferente') {
                    for (let bt of it.fare_str.split(',')) {
                      if (bt.toLowerCase().split(':')[0] == 'preferente') {
                        return true;
                      }
                    }
                  } else if (f.value.toLowerCase().indexOf('vent') > -1) {
                    for (let bt of it.fare_str.split(',')) {
                      if (
                        bt
                          .toLowerCase()
                          .split(':')[0]
                          .indexOf('vent') > -1
                      ) {
                        return true;
                      }
                    }
                  } else if (f.value.toLowerCase().indexOf('clasico') > -1) {
                    for (let bt of it.fare_str.split(',')) {
                      if (
                        bt
                          .toLowerCase()
                          .split(':')[0]
                          .indexOf('clasico') > -1
                      ) {
                        return true;
                      }
                    }
                  }
                  //  if (type.toLowerCase() == 'clasico') {
                  //   type2 = 'Clásico';
                  // }

                  // if(it.bus_type.split(' ').join('-').toLowerCase().indexOf(f.value.toLowerCase()) >= 0){
                  //   return true
                  // }
                }
              } else {
                return true;
              }
            }
          });
        }
      }
      routes.routes = filteredRoutes;
      this.setState({
        serviceList: routes,
      });
      // console.log('Routes List', this.state.serviceList);
    } catch (e) {
      console.log(e);
    }
  }

  renderServiceLoader = () => {
    return (
      <div className="service-loader center-text">
        <span>
          <img className="animation-gif" src="/images/animations/animation.gif" alt="img" />
          <div style={{ marginTop: 10 }}>
            <span className="grey-text font12">{this.props.t('TRANSLATIONS.LOADING_MESSAGE')}</span>
          </div>
        </span>
      </div>
    );
  };

  closeLayout = step => {
    this.clearSelectedSeats(step);
    this.props.actions.setSelectedService(null);
  };

  isFilterSelected = () => {
    for (let f of this.state.filtersArray) {
      for (let o of f.options) {
        if (o.active) {
          return true;
        }
      }
    }
    return false;
  };

  clearFilter = () => {
    let filters = CommonService.copyObject(this.state.filtersArray);
    for (let f of filters) {
      for (let o of f.options) {
        o.active = false;
      }
    }
    this.setState({ filtersArray: filters, filterSelected: false });
    this.filterBy(filters);
  };

  renderServicePageBody = () => {
    console.log('this.state.serviceList------------', this.state.serviceList);
    return (
      <div className="content-container services-main-container">
        <ServiceFilter
          t={this.props.t}
          filtersArray={this.state.filtersArray}
          onFilterSelected={this.onFilterSelected}
          onFilterClear={val => {
            this.setState({ filtersArray: val });
            this.filterBy(val);
          }}
        />
        <div className="services-list-container">
          <KuposCapsuleMenu
            t={this.props.t}
            menuButtons={this.capsuleMenuIcons}
            tab={true}
            activeTab={this.state.activeSortTab}
            onTabChange={i => this.sortBy(i)}
            showSortIcon={true}
            sortType={this.state.orderBy}
          />

          <div className="service-cards-container">
            {/* {console.log(
              'Service List rendered-------#######',
              this.state.serviceList.routes.length,
            )} */}
            {/* {console.log('this.props.pbServiceList.selectedServiceOnward.boardingStage')} */}
            {(!this.tripStep || this.tripStep == 1) &&
            this.props.pbServiceList.serviceList &&
            this.props.pbServiceList.selectedServiceOnward &&
            this.state.serviceList &&
            this.state.serviceList.routes &&
            this.props.home
              ? this.state.serviceList.routes.map((val, key) => {
                  return val.available_seats > 0 &&
                    (val.travel_id == this.operatorId || !this.operatorId) ? (
                    <ServiceItem
                      key={key}
                      t={this.props.t}
                      serviceItem={val}
                      metaData={this.props.home.metaData}
                      otherDate={this.props.pbServiceList.bookingDetailsOnward}
                      onBookButtonPress={() => this.onBookButtonPress(val, 1)}
                      terminals={this.props.home.terminals}
                      seatsCleared={this.state.seatsCleared}
                    >
                      {!this.state.selectedServiceError &&
                      this.props.pbServiceList.selectedService &&
                      this.props.pbServiceList.selectedServiceOnward.coachLayoutJson &&
                      this.props.pbServiceList.selectedService.id == val.id ? (
                        <SelectedServiceMore
                          key={
                            (this.props.pbServiceList.selectedServiceReturn.droppingStage
                              ? this.props.pbServiceList.selectedServiceReturn.droppingStage.id
                              : '') +
                            (this.props.pbServiceList.selectedServiceOnward.boardingStage
                              ? this.props.pbServiceList.selectedServiceOnward.boardingStage.id
                              : '') +
                            (this.props.pbServiceList.selectedServiceReturn.originStageDetails
                              ? this.props.pbServiceList.selectedServiceReturn.originStageDetails
                                  .length
                              : '') +
                            (this.props.pbServiceList.selectedServiceReturn.destinationStageDetails
                              ? this.props.pbServiceList.selectedServiceReturn
                                  .destinationStageDetails.length
                              : '')
                          }
                          boardingOptions={
                            this.props.pbServiceList.selectedServiceOnward.originStageDetails
                          }
                          droppingOptions={
                            this.props.pbServiceList.selectedServiceOnward.destinationStageDetails
                          }
                          selectedBoarding={
                            this.props.pbServiceList.selectedServiceOnward.boardingStage
                          }
                          selectedDropping={
                            this.props.pbServiceList.selectedServiceOnward.droppingStage
                          }
                          onBoardingPointChange={this.onBoardingPointChange}
                          onDroppingPointChange={this.onDroppingPointChange}
                          metaData={this.props.home.metaData}
                          coachLayout={
                            this.props.pbServiceList.selectedServiceOnward.coachLayoutJson
                          }
                          upperAvalibility={
                            this.props.pbServiceList.selectedServiceOnward.upperAvalibility
                          }
                          selectedSeatsToBook={
                            this.props.pbServiceList.bookingDetailsOnward
                              ? this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook
                              : null
                          }
                          onFloorChange={floor => this.floorChange(floor)}
                          selectedFloor={this.state.floor}
                          onSeatSelect={seat => this.onSeatSelectOnward(seat)}
                          onContinueButtonClick={this.continue}
                          bookingDetails={this.props.pbServiceList.bookingDetailsOnward}
                          t={this.props.t}
                          closeLayout={() => this.closeLayout(1)}
                          serviceType={this.props.home.pbSetType}
                          boardingErrorMessage={this.state.boardingErrorMessage}
                          droppingErrorMessage={this.state.droppingErrorMessage}
                          selectedService={this.props.pbServiceList.selectedServiceOnward}
                          serviceDetails={val}
                        />
                      ) : null}

                      {this.props.pbServiceList.getSelectedServicePending &&
                      this.state.selectedService &&
                      this.state.selectedService.id == val.id ? (
                        <div className="service-card-more-details">
                          {this.renderServiceLoader()}
                        </div>
                      ) : null}

                      {this.state.selectedServiceError &&
                      this.state.selectedService &&
                      this.state.selectedService.id == val.id ? (
                        <div className="service-card-more-details">
                          <span className="service-error-msg">
                            {this.state.selectedServiceError}
                          </span>
                        </div>
                      ) : null}
                    </ServiceItem>
                  ) : null;
                })
              : null}
            {(!this.tripStep || this.tripStep == 1) &&
            this.props.pbServiceList.serviceList &&
            this.props.pbServiceList.selectedServiceOnward &&
            this.state.serviceList &&
            this.state.serviceList.routes
              ? this.state.serviceList.routes.map((val, key) => {
                  return val.available_seats <= 0 &&
                    (val.travel_id == this.operatorId || !this.operatorId) ? (
                    <ServiceItem
                      key={key}
                      t={this.props.t}
                      serviceItem={val}
                      metaData={this.props.home.metaData}
                      otherDate={this.props.pbServiceList.bookingDetailsOnward}
                      onBookButtonPress={() => this.onBookButtonPress(val, 1)}
                    >
                      {!this.state.selectedServiceError &&
                      this.props.pbServiceList.selectedService &&
                      this.props.pbServiceList.selectedServiceOnward.coachLayoutJson &&
                      this.props.pbServiceList.selectedService.id == val.id ? (
                        <SelectedServiceMore
                          key={
                            (this.props.pbServiceList.selectedServiceReturn.droppingStage
                              ? this.props.pbServiceList.selectedServiceReturn.droppingStage.id
                              : '') +
                            (this.props.pbServiceList.selectedServiceOnward.boardingStage
                              ? this.props.pbServiceList.selectedServiceOnward.boardingStage.id
                              : '') +
                            (this.props.pbServiceList.selectedServiceReturn.originStageDetails
                              ? this.props.pbServiceList.selectedServiceReturn.originStageDetails
                                  .length
                              : '') +
                            (this.props.pbServiceList.selectedServiceReturn.destinationStageDetails
                              ? this.props.pbServiceList.selectedServiceReturn
                                  .destinationStageDetails.length
                              : '')
                          }
                          boardingOptions={
                            this.props.pbServiceList.selectedServiceOnward.originStageDetails
                          }
                          droppingOptions={
                            this.props.pbServiceList.selectedServiceOnward.destinationStageDetails
                          }
                          selectedBoarding={
                            this.props.pbServiceList.selectedServiceOnward.boardingStage
                          }
                          selectedDropping={
                            this.props.pbServiceList.selectedServiceOnward.droppingStage
                          }
                          onBoardingPointChange={this.onBoardingPointChange}
                          onDroppingPointChange={this.onDroppingPointChange}
                          metaData={this.props.home.metaData}
                          coachLayout={
                            this.props.pbServiceList.selectedServiceOnward.coachLayoutJson
                          }
                          upperAvalibility={
                            this.props.pbServiceList.selectedServiceOnward.upperAvalibility
                          }
                          selectedSeatsToBook={
                            this.props.pbServiceList.bookingDetailsOnward
                              ? this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook
                              : null
                          }
                          onFloorChange={floor => this.floorChange(floor)}
                          selectedFloor={this.state.floor}
                          onSeatSelect={seat => this.onSeatSelectOnward(seat)}
                          onContinueButtonClick={this.continue}
                          bookingDetails={this.props.pbServiceList.bookingDetailsOnward}
                          t={this.props.t}
                          closeLayout={() => this.closeLayout(1)}
                          boardingErrorMessage={this.state.boardingErrorMessage}
                          droppingErrorMessage={this.state.droppingErrorMessage}
                          selectedService={this.props.pbServiceList.selectedServiceOnward}
                          serviceDetails={val}
                        />
                      ) : null}

                      {this.props.pbServiceList.getSelectedServicePending &&
                      this.state.selectedService &&
                      this.state.selectedService.id == val.id ? (
                        <div className="service-card-more-details">
                          {this.renderServiceLoader()}
                        </div>
                      ) : null}

                      {this.state.selectedServiceError &&
                      this.state.selectedService &&
                      this.state.selectedService.id == val.id ? (
                        <div className="service-card-more-details">
                          <span className="service-error-msg">
                            {this.state.selectedServiceError}
                          </span>
                        </div>
                      ) : null}
                    </ServiceItem>
                  ) : null;
                })
              : null}
            {this.tripStep == 2 &&
            this.props.pbServiceList.serviceListReturn &&
            this.props.pbServiceList.selectedServiceReturn &&
            this.state.serviceList &&
            this.state.serviceList.routes
              ? this.state.serviceList.routes.map((val, key) => {
                  return val.available_seats > 0 ? (
                    <ServiceItem
                      key={key}
                      t={this.props.t}
                      serviceItem={val}
                      metaData={this.props.home.metaData}
                      key={key}
                      onBookButtonPress={() => this.onBookButtonPress(val, 2)}
                    >
                      {!this.state.selectedServiceError &&
                      this.props.pbServiceList.selectedService &&
                      this.props.pbServiceList.selectedServiceReturn.coachLayoutJson &&
                      this.props.pbServiceList.selectedService.id == val.id ? (
                        <SelectedServiceMore
                          key={
                            (this.props.pbServiceList.selectedServiceReturn.droppingStage
                              ? this.props.pbServiceList.selectedServiceReturn.droppingStage.id
                              : '') +
                            (this.props.pbServiceList.selectedServiceOnward.boardingStage
                              ? this.props.pbServiceList.selectedServiceOnward.boardingStage.id
                              : '') +
                            (this.props.pbServiceList.selectedServiceReturn.originStageDetails
                              ? this.props.pbServiceList.selectedServiceReturn.originStageDetails
                                  .length
                              : '') +
                            (this.props.pbServiceList.selectedServiceReturn.destinationStageDetails
                              ? this.props.pbServiceList.selectedServiceReturn
                                  .destinationStageDetails.length
                              : '')
                          }
                          boardingOptions={
                            this.props.pbServiceList.selectedServiceReturn.originStageDetails
                          }
                          droppingOptions={
                            this.props.pbServiceList.selectedServiceReturn.destinationStageDetails
                          }
                          selectedBoarding={
                            this.props.pbServiceList.selectedServiceReturn.boardingStage
                          }
                          selectedDropping={
                            this.props.pbServiceList.selectedServiceReturn.droppingStage
                          }
                          onBoardingPointChange={this.onBoardingPointChange}
                          onDroppingPointChange={this.onDroppingPointChange}
                          metaData={this.props.home.metaData}
                          coachLayout={
                            this.props.pbServiceList.selectedServiceReturn.coachLayoutJson
                          }
                          upperAvalibility={
                            this.props.pbServiceList.selectedServiceReturn.upperAvalibility
                          }
                          selectedSeatsToBook={
                            this.props.pbServiceList.bookingDetailsReturn
                              ? this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook
                              : null
                          }
                          onFloorChange={floor => this.floorChange(floor)}
                          selectedFloor={this.state.floor}
                          onSeatSelect={seat => this.onSeatSelectReturn(seat)}
                          onContinueButtonClick={this.continue}
                          bookingDetails={this.props.pbServiceList.bookingDetailsReturn}
                          t={this.props.t}
                          closeLayout={() => this.closeLayout(2)}
                          boardingErrorMessage={this.state.boardingErrorMessage}
                          droppingErrorMessage={this.state.droppingErrorMessage}
                          selectedService={this.props.pbServiceList.selectedServiceReturn}
                          serviceDetails={val}
                        />
                      ) : null}

                      {this.props.pbServiceList.getSelectedServicePending &&
                      this.state.selectedService &&
                      this.state.selectedService.id == val.id ? (
                        <div className="service-card-more-details">
                          {this.renderServiceLoader()}
                        </div>
                      ) : null}

                      {this.state.selectedServiceError &&
                      this.state.selectedService &&
                      this.state.selectedService.id == val.id ? (
                        <div className="service-card-more-details">
                          <span className="service-error-msg">
                            {this.state.selectedServiceError}
                          </span>
                        </div>
                      ) : null}
                    </ServiceItem>
                  ) : null;
                })
              : null}
            {this.tripStep == 2 &&
            this.props.pbServiceList.serviceListReturn &&
            this.props.pbServiceList.selectedServiceReturn &&
            this.state.serviceList &&
            this.state.serviceList.routes
              ? this.state.serviceList.routes.map((val, key) => {
                  return val.available_seats <= 0 ? (
                    <ServiceItem
                      key={key}
                      t={this.props.t}
                      serviceItem={val}
                      metaData={this.props.home.metaData}
                      key={key}
                      onBookButtonPress={() => this.onBookButtonPress(val, 2)}
                    >
                      {!this.state.selectedServiceError &&
                      this.props.pbServiceList.selectedService &&
                      this.props.pbServiceList.selectedServiceReturn.coachLayoutJson &&
                      this.props.pbServiceList.selectedService.id == val.id ? (
                        <SelectedServiceMore
                          key={
                            (this.props.pbServiceList.selectedServiceReturn.droppingStage
                              ? this.props.pbServiceList.selectedServiceReturn.droppingStage.id
                              : '') +
                            (this.props.pbServiceList.selectedServiceOnward.boardingStage
                              ? this.props.pbServiceList.selectedServiceOnward.boardingStage.id
                              : '') +
                            (this.props.pbServiceList.selectedServiceReturn.originStageDetails
                              ? this.props.pbServiceList.selectedServiceReturn.originStageDetails
                                  .length
                              : '') +
                            (this.props.pbServiceList.selectedServiceReturn.destinationStageDetails
                              ? this.props.pbServiceList.selectedServiceReturn
                                  .destinationStageDetails.length
                              : '')
                          }
                          boardingOptions={
                            this.props.pbServiceList.selectedServiceReturn.originStageDetails
                          }
                          droppingOptions={
                            this.props.pbServiceList.selectedServiceReturn.destinationStageDetails
                          }
                          selectedBoarding={
                            this.props.pbServiceList.selectedServiceReturn.boardingStage
                          }
                          selectedDropping={
                            this.props.pbServiceList.selectedServiceReturn.droppingStage
                          }
                          onBoardingPointChange={this.onBoardingPointChange}
                          onDroppingPointChange={this.onDroppingPointChange}
                          metaData={this.props.home.metaData}
                          coachLayout={
                            this.props.pbServiceList.selectedServiceReturn.coachLayoutJson
                          }
                          upperAvalibility={
                            this.props.pbServiceList.selectedServiceReturn.upperAvalibility
                          }
                          selectedSeatsToBook={
                            this.props.pbServiceList.bookingDetailsReturn
                              ? this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook
                              : null
                          }
                          onFloorChange={floor => this.floorChange(floor)}
                          selectedFloor={this.state.floor}
                          onSeatSelect={seat => this.onSeatSelectReturn(seat)}
                          onContinueButtonClick={this.continue}
                          bookingDetails={this.props.pbServiceList.bookingDetailsReturn}
                          t={this.props.t}
                          closeLayout={() => this.closeLayout(2)}
                          boardingErrorMessage={this.state.boardingErrorMessage}
                          droppingErrorMessage={this.state.droppingErrorMessage}
                          selectedService={this.props.pbServiceList.selectedServiceReturn}
                          serviceDetails={val}
                        />
                      ) : null}

                      {this.props.pbServiceList.getSelectedServicePending &&
                      this.state.selectedService &&
                      this.state.selectedService.id == val.id ? (
                        <div className="service-card-more-details">
                          {this.renderServiceLoader()}
                        </div>
                      ) : null}

                      {this.state.selectedServiceError &&
                      this.state.selectedService &&
                      this.state.selectedService.id == val.id ? (
                        <div className="service-card-more-details">
                          <span className="service-error-msg">
                            {this.state.selectedServiceError}
                          </span>
                        </div>
                      ) : null}
                    </ServiceItem>
                  ) : null;
                })
              : null}
          </div>

          {/* {console.log('Service list available', this.state.serviceList.routes)} */}

          {this.props.serviceList && this.state.serviceList.routes.length < 1 ? (
            <div className="content-container cancel-done-section">
              <div className="cancel-ticket-done">
                <img src={'/images/icons/circular-icons/icon-failure.png'} alt="" />
              </div>

              <div className="mt-y-3 cancel-ticket-done">
                <span className="bold-text font20">{this.props.t('HOME.WE_ARE_SORRY')}</span>
              </div>

              <div className="mt-y-3 cancel-ticket-done cancel-ticket-done-desc font12">
                <span style={{ textAlign: 'center' }}>
                  {'No tenemos servicios disponibles con las características que seleccionaste.'}
                </span>
              </div>

              <div className="cancel-success-info-container">
                <div className="mt-y-3 cancel-ticket-done cancel-success-info-div-no-results font12">
                  <span className="primary-triangle"></span>
                  <span>{'Por favor intenta eliminando los filtros.'} </span>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  };

  // renderChangeFilerPopup = () =>{
  //   // this.setState({ showFilterModal : true});
  //   return (

  //   );
  // }

  renderPaymentLoadingDiv = () => {
    return (
      <div className="payment-loader content-container">
        <span>Loader</span>
      </div>
    );
  };

  swapCities = () => {
    let source = CommonService.copyObject(this.props.home.pbSourceCity);
    let dest = CommonService.copyObject(this.props.home.pbDestinationCity);
    this.props.actions.pbSetSourceCity(dest);
    this.props.actions.pbSetDestinationCity(source);
  };

  renderNoResultsFoundPage = () => {
    return (
      <div className="no-results-found">
        <KuposSuccessFailure
          title={this.props.t('HOME.WE_ARE_SORRY')}
          subtitle={this.props.t('HOME.NO_SERVICE')}
          infoText={this.props.t('HOME.TRY_OTHER_DEST')}
          t={this.props.t}
        >
          <div className="kupos-card">
            <NewSearchBox
              cities={
                !CommonService.isTrain()
                  ? this.props.home.uniqueCities
                  : this.props.home.uniqueCitiesTrain
              }
              openNewSearch={this.props.pbServiceList.openNewSearch}
              pbSourceCity={this.props.home.pbSourceCity}
              sourceCityOnChange={this.props.actions.pbSetSourceCity}
              pbDestinationCity={this.props.home.pbDestinationCity}
              destinationCityOnChange={this.props.actions.pbSetDestinationCity}
              onwardPBDate={this.props.home.onwardPBDate}
              onwardDateChange={this.props.actions.setOnwardPbDate}
              returnPBDate={this.props.home.returnPBDate}
              returnDateChange={this.props.actions.setReturnPbDate}
              swapCities={this.swapCities}
              newSearch={this.newSearch}
              t={this.props.t}
            />
          </div>
        </KuposSuccessFailure>
      </div>
    );
  };

  render() {
    const { t } = this.props;
    return (
      <div className="pb-service-list-default-page">
        {/* <TopStrip classes={"header-box "+(this.pageType ? 'payments-page-header' : '')} history={this.props.history}>
            {this.pageType != 'passenger-details' ? this.renderSelectedSearchBox() : null}
          </TopStrip> */}
        {/* {this.renderNewSearchForm()} */}

        <Helmet>
          <title>{`pullmanbus.cl | ${this.originCityDecoded} - ${this.destCityDecoded}`}</title>
          <meta
            name="description"
            content={`pullmanbus.cl | ${this.originCityDecoded} - ${this.destCityDecoded}`}
          />
        </Helmet>

        {/* commented by tanveer on Amit's feedback */}
        {this.state.serviceList != 'NO_ROUTES_FOUND' ? (
          <div className="content-container">
            <KuposSteps
              menuButtons={this.state.stepsMenu}
              t={this.props.t}
              onStepClick={this.onStepClick}
            />
          </div>
        ) : null}

        {!this.state.getServiceListPending && this.state.serviceList ? (
          this.state.serviceList != 'NO_ROUTES_FOUND' ? (
            this.renderServicePageBody()
          ) : (
            this.renderNoResultsFoundPage()
          )
        ) : (
          <div className="content-container"> {this.renderServiceLoader()}</div>
        )}

        <KuposErrorSuccessModal
          showModal={this.state.showFilterModal}
          onHide={() => {
            this.setState({ showFilterModal: false, showFilterModalMessage: '' });
            if (this.state.filterSelected) {
              // this.clearFilter();
            }
          }}
          onButtonClick={() => {
            this.setState({
              showFilterModal: false,
              showFilterModalMessage: '',
            });
            seatsSelected = 0;
            if (this.state.filterSelected) {
              // this.clearFilter();
            }
          }}
          success={false}
          subTitle={t(this.state.showFilterModalMessage).replace(
            '8',
            (this.props.pbServiceList.selectedService &&
              this.props.pbServiceList.selectedService.res_details &&
              this.props.pbServiceList.selectedService.res_details.no_of_seats_to_be_booked) ||
              8,
          )}
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pbServiceList: state.pbServiceList,
    home: state.home,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...homeActions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('common')(DefaultPageTrain));



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/DefaultPageTrain.js